import { Observable } from "rxjs";
import { Injectable } from "@angular/core";
import { CoreService } from "../../base/core";
import { CommonHttpOption } from "../../base/common-http-option";
import { ServiceRoute } from "../../base/service-route";
import { IPlacementReservationAdd } from "src/app/interfaces/placementReservationAdd";
import { IRegistration } from "src/app/interfaces/registration";

@Injectable({
  providedIn: 'root'
})
export class StudentService {
  constructor(private core: CoreService) { }

  getTest(_DateEnd: Date): Observable<any> {
    return this.core.get(
      ServiceRoute.student.getTest,
      // ServiceRoute.student.coursesRegistered.getTest,
      new CommonHttpOption().headers
    );
  }
  // course
  getRegistrationCourses(pageIndex: number, pageSize: number): Observable<any> {
    return this.core.get(
      ServiceRoute.student.course.getRegistrationCourses,
      new CommonHttpOption().headers,
      new CommonHttpOption().paginator(pageIndex, pageSize, "Id", true)
    );
  }

  getMarkStudentSTU(params: any): Observable<any> {
    return this.core.get(
      ServiceRoute.student.course.markStudentSTU + params.Id,
      new CommonHttpOption().headers,
    );
  }
  getQuestionList(params: any): Observable<any> {
    return this.core.get(
      ServiceRoute.student.course.questionListStudentNotAnswerSTU + params.Id,
      new CommonHttpOption().headers,
    );
  }

  coursesTypeByCurentBranch(params: any): Observable<any> {
    return this.core.get(
      ServiceRoute.student.course.courseTypeListByCurentBranchSTU + params.branchEncryptId,
      new CommonHttpOption().headers
    );
  }

  coursesTypeByCurentBranchAndLevel(params: any): Observable<any> {
    return this.core.get(
      ServiceRoute.student.course.courseTypeListByCurentBranchAndLevelSTU + params.branchEncryptId + '&levelInfoId=' + params.LevelInfoId,
      new CommonHttpOption().headers
    );
  }

  getLevelsSTU(params: any): Observable<any> {
    return this.core.get(
      ServiceRoute.student.course.getListLevelFromNationalCodeSTU + encodeURI(params.holdingEncryptId),
      new CommonHttpOption().headers
    );
  }

  getNextLevelForQuickRegister(params: any): Observable<any> {
    return this.core.get(
      ServiceRoute.student.registration.getNextLevelForQuickRegister + encodeURI(params.holdingEncryptId),
      new CommonHttpOption().headers
    );
  }

  getCourseInfoById(params: any): Observable<any> {
    return this.core.get(
      ServiceRoute.student.course.getCourseInfoById + params.Id,
      new CommonHttpOption().headers
    );
  }

  surveyListAdd(data: any): Observable<any> {
    return this.core.post(
      ServiceRoute.student.course.surveyListAdd,
      data,
      new CommonHttpOption().headers
    );
  }
  // course / PackageEducation
  getBranchListByNationalCodeAndPackage(
    command: any
  ): Observable<any> {
    return this.core.post(
      ServiceRoute.student.course.getBranchListByNationalCodeAndPackageSTU,
      command,
      new CommonHttpOption().headers
    );
  }

  getListByJustCourseTypeIdSTU(data: {}): Observable<any> {
    return this.core.post(
      ServiceRoute.student.course.listByJustCourseTypeIdSTU,
      data,
      new CommonHttpOption().headers
    );
  }

  // course / registration
  ListCourseForRegisterSTU(data: any): Observable<any> {
    return this.core.post(
      ServiceRoute.student.course.listCourseForRegisterSTU,
      data,
      new CommonHttpOption().headers
    );
  }

  // course /  DiscountGroup

  discountPersonList(params: any): Observable<any> {
    return this.core.get(
      ServiceRoute.student.course.discountPersonListSTU + params.courseId,
      new CommonHttpOption().headers
    );
  }

  // course /  CustomerContractUN

  getUnderstandingDiscountCombo(params: any): Observable<any> {
    return this.core.get(
      ServiceRoute.student.course.getUnderstandingDiscountCombo + params.courseId,
      new CommonHttpOption().headers
    );
  }

  getLatestRegistrationArea(nationalCode: string): Observable<any> {
    return this.core.get(
      ServiceRoute.student.registration.getLatestRegistrationArea + nationalCode,
      new CommonHttpOption().headers
    );
  }

  // course /  DiscountGroup
  add(data: IRegistration): Observable<any> {
    return this.core.post(
      ServiceRoute.student.course.addSTU,
      data,
      new CommonHttpOption().headers
    );
  }
  // Placement
  getPlacementsStatus(pageIndex: number = 1, pageSize: number = 10): Observable<any> {
    return this.core.get(
      ServiceRoute.student.placement.getListSTU,
      new CommonHttpOption().headers,
      new CommonHttpOption().paginator(pageIndex, pageSize, "Id", true)
    );
  }
  getPlacementReservations(pageIndex: number, pageSize: number): Observable<any> {
    return this.core.get(
      ServiceRoute.student.placement.getPlacementReservations,
      new CommonHttpOption().headers,
      new CommonHttpOption().paginator(pageIndex, pageSize, "Id", true)
    );
  }
  // Placement / PlacementReservation
  reservationAdd(command: IPlacementReservationAdd): Observable<any> {
    return this.core.post(
      ServiceRoute.student.placement.reservationAdd,
      command,
      new CommonHttpOption().headers
    );
  }
  // Placement / PlacementType
  getPlacementTypeListSTU(params: any, pageIndex: number = 0, pageSize: number = 0): Observable<any> {
    return this.core.get(
      ServiceRoute.student.placement.placementTypeListSTU,
      new CommonHttpOption().headers,
      new CommonHttpOption()
        .paginator(pageIndex, pageSize, "Id", true)
        .append('HoldingEncryptId', params && params.HoldingEncryptId ? params.HoldingEncryptId : '')
        .append('BranchEncryptId', params && params.BranchEncryptId ? params.BranchEncryptId : '')
        .append('PackageId', params && params.packageId ? params.packageId : '')
    );
  }
  // Placement / PlacementTimeSheet
  getDateList(command: any): Observable<any> {
    return this.core.post(
      ServiceRoute.student.placement.getDateList,
      command,
      new CommonHttpOption().headers
    );
  }
  // Placement / PlacementReservation
  placementReservationTime(command: any): Observable<any> {
    return this.core.post(
      ServiceRoute.student.placement.placementReservationTimeSTU,
      command,
      new CommonHttpOption().headers
    );
  }
  // Discount
  getPersonDocuments(page: number = 1, pageSize: number = 10): Observable<any> {
    return this.core.get(
      ServiceRoute.student.discount.getPersonDocuments,
      new CommonHttpOption().headers,
      new CommonHttpOption().paginator(page, pageSize)
    );
  }
  sendDocument(data: any): Observable<any> {
    return this.core.post(
      ServiceRoute.student.discount.sendDocument,
      data,
      new CommonHttpOption().headers
    );
  }

  editDocument(data: any): Observable<any> {
    return this.core.put(
      ServiceRoute.student.discount.editDocument,
      data,
      new CommonHttpOption().headers
    );
  }

  discountGroupPersonList(params: any, page = 0, pageSize = 0): Observable<any> {
    return this.core.get(
      ServiceRoute.student.discount.discountGroupPersonList,
      new CommonHttpOption().headers,
      new CommonHttpOption().paginator(page, pageSize)
        .append('HoldingEncriptId', params && params.holdingEncryptId ? params.holdingEncryptId : '')
    );
  }
  // Invoice
  getInvoiceComonSTU(params: any, pageIndex: number = 1, pageSize: number = 10): Observable<any> {
    return this.core.get(
      ServiceRoute.student.invoce.invoiceComonSTU,
      new CommonHttpOption().headers,
      new CommonHttpOption()
        .paginator(pageIndex, pageSize, "Id", true)
        .append('Id', params && params.Id ? params.Id : '')
        .append('InvoiceItemTypeId', params && params.InvoiceItemTypeId ? params.InvoiceItemTypeId : '')
        .append('InvoiceStatusId', params && params.InvoiceStatusId ? params.InvoiceStatusId : '')
        .append('InvoiceCounterNumber', params && params.InvoiceCounterNumber ? params.InvoiceCounterNumber : '')
    );
  }
  getInvoiceVoucherRowForStudent(id: number): Observable<any> {
    return this.core.get(
      ServiceRoute.student.invoce.GetInvoiceVoucherRowForStudent + id,
      new CommonHttpOption().headers
    );
  }

}
